const footerItemList = [
    {
        title: 'Products & Services',
        linkList: [
            {
                href: 'https://www.sgcarmart.com/new-cars',
                key: 'newCarsForSale',
                text: 'New Cars',
            },
            {
                href: 'https://www.sgcarmart.com/used-cars',
                key: 'usedCarsForSale',
                text: 'Used Cars',
            },
            {
                href: 'https://www.sgcarmart.com/electric-vehicle',
                key: 'electricCarsForSale',
                text: 'Electric Cars',
            },
            {
                href: 'https://www.sgcarmart.com/hybrid-vehicle',
                key: 'hybridCarsForSale',
                text: 'Hybrid Cars',
            },
            {
                href: 'https://www.sgcarmart.com/car_rental/index.php',
                key: 'carsForLoan',
                text: 'Car Loan',
            },
            {
                href: 'https://www.sgcarmart.com/car_rental/index.php',
                key: 'carsForRent',
                text: 'Rental Cars',
            },
            {
                href: 'https://www.sgcarmart.com/sell-car',
                key: 'carsForSell',
                text: 'Sell Cars',
            },
            {
                href: 'https://www.sgcarmart.com/articles',
                key: 'carsArticle',
                text: 'Article',
            },
            {
                href: 'https://www.sgcarmart.com/forum/index.php',
                key: 'carsForum',
                text: 'Forum',
            },
            {
                href: 'https://www.sgcarmart.com/resources',
                key: 'carsResources',
                text: 'Resources',
            },
        ],
    },
    {
        title: 'For Owners',
        linkList: [
            {
                href: 'https://www.sgcarmart.com/shop',
                key: 'eShop',
                text: 'e-Shop',
            },
            {
                href: 'https://www.sgcarmart.com/directory/index.php',
                key: 'workshop',
                text: 'Workshop',
            },
            {
                href: 'https://www.sgcarmart.com/products/index.php',
                key: 'products',
                text: 'Products',
            },
            {
                href: 'https://www.sgcarmart.com/car-insurance',
                key: 'insurance',
                text: 'Insurance',
            },
            {
                href: 'https://www.sgcarmart.com/events',
                key: 'events',
                text: 'Events',
            },
        ],
    },
    {
        title: 'Quick Links',
        linkList: [
            {
                href: 'https://www.sgcarmart.com/carpark?TYP=Carpark',
                key: 'carparkRates',
                text: 'Carpark Rates',
            },
            {
                href: 'https://www.sgcarmart.com/directory/carplate_index.php',
                key: 'biddedCarplates',
                text: 'Bidded Carplates',
            },
            {
                href: 'https://www.sgcarmart.com/coe-price',
                key: 'coePrices',
                text: 'COE Prices',
            },
            {
                href: 'https://www.sgcarmart.com/resources/car-loan-calculator',
                key: 'loanCalculator',
                text: 'Loan Calculator',
            },
            {
                href: 'https://www.sgcarmart.com/articles/car-reviews',
                key: 'carReviews',
                text: 'Car Reviews',
            },
            {
                href: 'https://www.sgcarmart.com/articles/advice',
                key: 'carAdvice',
                text: 'Car Advice',
            },
        ],
    },
    {
        title: 'About Sgcarmart',
        linkList: [
            {
                href: 'https://www.sgcarmart.com/about',
                key: 'aboutUs',
                text: 'About Us',
            },
            {
                href: 'https://www.sgcarmart.com/contact',
                key: 'contactUs',
                text: 'Contact Us',
            },
            {
                href: 'https://www.sgcarmart.com/careers',
                key: 'careers',
                text: 'Careers',
            },
        ],
    },
];

export { footerItemList as f };
//# sourceMappingURL=configs-DLiFtVTn.js.map
